"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedPointTypeEnum = void 0;
/**
 * Типы красных точек
 */
var RedPointTypeEnum;
(function (RedPointTypeEnum) {
  /**
   * Мой урок создан и отправлен на модерацию
   */
  RedPointTypeEnum[RedPointTypeEnum["my_lesson_moderation"] = 1] = "my_lesson_moderation";
  /**
   * Мой урок одобрен модератором
   */
  RedPointTypeEnum[RedPointTypeEnum["my_lesson_published"] = 2] = "my_lesson_published";
  /**
   * Моя коллекция создана и отправлена на модерацию
   */
  RedPointTypeEnum[RedPointTypeEnum["my_collection_moderation"] = 3] = "my_collection_moderation";
  /**
   * Моя коллекция одобрена модератором
   */
  RedPointTypeEnum[RedPointTypeEnum["my_collection_published"] = 4] = "my_collection_published";
  /**
   * Моя услуга создана и отправлена на модерацию
   */
  RedPointTypeEnum[RedPointTypeEnum["my_user_service_moderation"] = 5] = "my_user_service_moderation";
  /**
   * Моя услуга одобрена модератором
   */
  RedPointTypeEnum[RedPointTypeEnum["my_user_service_published"] = 6] = "my_user_service_published";
  /**
   * Оставлен комментарий к моей публикации или уроку
   * либо к публикации или уроку, где я оставлял комментарий
   */
  RedPointTypeEnum[RedPointTypeEnum["content_commented"] = 7] = "content_commented";
  /**
   * Новая публикация у того, на кого я подписан
   * либо у классрума или школы в которых я являюсь участником
   */
  RedPointTypeEnum[RedPointTypeEnum["content_published"] = 8] = "content_published";
  /**
   * Я купил коллекцию
   */
  RedPointTypeEnum[RedPointTypeEnum["collection_purchased"] = 9] = "collection_purchased";
  /**
   * Я добавил сущность или пользователя в избранное
   */
  RedPointTypeEnum[RedPointTypeEnum["bookmark"] = 10] = "bookmark";
})(RedPointTypeEnum = exports.RedPointTypeEnum || (exports.RedPointTypeEnum = {}));
